// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__paoTq","container":"style_container__02fdY","plusIcon":"style_plusIcon__gvZAd","accordion-title":"style_accordion-title__H2+kH"};